import { Injectable } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { LeadService } from 'src/app/private/services/lead.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Injectable({
    providedIn: 'root',
})
export class LeadActivityService {
    private leadActivityList = new BehaviorSubject<any[]>([]);
    leadActivity$ = this.leadActivityList.asObservable(); // Expose tasks as observable

    constructor(
        private api: LeadService,
        private localStorage: LocalStorageService
    ) { }

    getAllLeadTimeLineActivity(lead_id: any) {

        const payload = {
            organization_id: this.localStorage.getOrganizationId(),
            lead_id: lead_id
        }

        this.api.getAllLeadActivity(payload).subscribe({
            next: data => {

                let formatedData = data.map((item: any) => {
                    return {
                        name: item.user?.fname + ' ' + item.user?.lname,
                        date: moment(item.createdAt).format('DD/MM/YYYY HH:mm'),
                        desc: item?.activity_description,
                        id: item.id,
                        restData: item
                    }
                });

                this.leadActivityList.next(formatedData || []);
            }
        });
    }

}
